import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea688aae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ea688aae&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=ea688aae&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea688aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea688aae')) {
      api.createRecord('ea688aae', component.options)
    } else {
      api.reload('ea688aae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ea688aae&scoped=true", function () {
      api.rerender('ea688aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/form/input/IkFormText/index.vue"
export default component.exports